import { Button, createStyles, makeStyles, Theme } from '@material-ui/core'
import { PhotoCamera } from '@material-ui/icons'
import React from 'react'
import { SharedDataProvider } from '../../../shared/providers/SharedDataProvider'
import { ImageController } from '../../../shared/controllers/ImageController'
import { MachineType } from '../../models/MachineType'
import { TermsController } from '../../../shared/controllers/ TermsController'

interface MachineTypePictureProps {
  machineType: MachineType
  machineTypePicture
  setMachineTypePicture
  selectedLanguage
}

export const MachineTypePicture = ({
  machineType,
  machineTypePicture,
  setMachineTypePicture,
  selectedLanguage,
}: MachineTypePictureProps) => {
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      appContent: {
        minHeight: '86vh',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        flexWrap: 'wrap',
        alignItems: 'center',
      },
      dataContainer: {
        marginTop: 30,
        marginLeft: 20,
        marginRight: 20,
      },
      button: {
        width: '100%',
        borderRadius: '10px',
        backgroundColor: '#1c8033',
        color: 'white',
        variant: 'contained',
        margin: 5,
        fontSize: 15,
        '&:hover': {
          backgroundColor: '#1c8033',
        },
      },
      deleteButton: {
        width: '100%',
        borderRadius: '10px',
        backgroundColor: '#f44336',
        color: 'white',
        variant: 'contained',
        margin: 5,
        fontSize: 15,
        '&:hover': {
          backgroundColor: '#d32215',
        },
      },
      machineTypePicture: {
        objectFit: 'contain',
        objectPosition: 'center',
        width: '240px',
        borderRadius: '50%',
      },
      hiddenInput: {
        display: 'none',
      },
    })
  )
  const classes = useStyles()

  const sharedDataProvider = new SharedDataProvider()
  const imageController: ImageController = new ImageController()

  async function imageUpload() {
    // get image
    let files = document.getElementById('imageUpload').files

    // transform image into base64
    // prepare image by resizing etc
    let file = await imageController.prepareImageForUploadSquared(files[0])
    let reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      let base64 = reader.result
      setMachineTypePicture(base64)
    }
  }

  const termsController = new TermsController()

  return (
    <div>
      <div className={classes.dataContainer}>
        <img
          className={classes.machineTypePicture}
          src={
            machineTypePicture
              ? machineTypePicture
              : sharedDataProvider.host +
                '/machineTypes/getMachineTypePicture?id=' +
                machineType._id +
                '&' +
                new Date()
          }
        ></img>

        <input
          className={classes.hiddenInput}
          type="file"
          id="imageUpload"
          accept="image/*"
          onChange={(e) => imageUpload()}
        />
      </div>

      <div className={classes.dataContainer}>
        <label htmlFor="imageUpload">
          <Button
            className={classes.button}
            component="span"
            startIcon={<PhotoCamera />}
          >
            {termsController.getTerm(
              'Maschinentypbild uploaden',
              selectedLanguage
            ) ||
              {
                de: 'Maschinentypbild uploaden',
                en: 'Upload Machinetype Picture',
                fr: 'Maschinentypbild Uploaden - FR',
              }[selectedLanguage]}
          </Button>
        </label>
      </div>
    </div>
  )
}
